export function getTelefoneCompleto(ddi: string | undefined, ddd: string | undefined, numero: string | undefined): string | undefined {
  if (!numero) {
    return undefined;
  }
  const newDdi = ddi ? `+${ddi}` : '';
  const newDdd = ddd || '';
  return `${newDdi}${newDdd}${numero}`;
}